<template>
    <div class="modal modal-delete fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-inner">

                        <slot name="body"></slot>

                        <div class="btns-wrap">
                            <button data-dismiss="modal" class="btn btn--outline-primary">
                                {{ rejectText }}
                            </button>
                            <button class="btn btn--secondary" @click="confirmation">
                                {{ confirmText }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ActionModal',
        props: {
            confirmText: String,
            modalId: {
                type: String,
                required: true,
            },
            rejectText: String,
        },
        emits: ['confirm'],
        methods: {
            confirmation () {
                $(`#${this.modalId}`).modal('hide');
                this.$emit('confirm');
            }
        }
    }
</script>

<style scoped>
</style>
